import React from 'react';
import {
  Box,
  Container,
  Paper,
  Typography,
  Grid,
  Avatar,
  Stack,
} from '@mui/material';
import Verified from '@mui/icons-material/Verified';
import FlashOn from '@mui/icons-material/FlashOn';
import Security from '@mui/icons-material/Security';

export default function About() {
  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 70px)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: { xs: '40px 16px', md: '80px 24px' },
        position: 'relative',
        background: '#0F2E2B',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background: `
            radial-gradient(650px 450px at 85% -10%, rgba(212,162,76,0.14), transparent 60%),
            radial-gradient(550px 450px at -10% 80%, rgba(47,143,118,0.18), transparent 60%)
          `,
          zIndex: 0,
        },
      }}
    >
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        {/* Title Section */}
        <Box sx={{ textAlign: 'center', mb: { xs: 6, md: 8 } }}>
          <Typography
            variant="h3"
            sx={{
              fontFamily: '"Fraunces", serif',
              fontWeight: 700,
              color: '#F5F1E6',
              mb: 2,
            }}
          >
            About iSoret
          </Typography>
          <Typography variant="body1" sx={{ color: 'rgba(245, 241, 230, 0.66)', maxWidth: '100%', mx: 'auto', lineHeight: 1.7 }}>
            India’s trusted digital coupon marketplace, where every coupon delivers guaranteed value through cashback and exclusive benefits.
            iSoret is a digital coupon marketplace developed and operated by  FLUX INFOTECH LLP.
            Our platform is dedicated to providing users with assured cashback, savings, and deals on a wide range of products and services.
            We believe in empowering shoppers to make smarter purchasing decisions by offering coupons that guarantee value with every transaction.
          </Typography>
        </Box>

        {/* 2-Column Story & Stats */}
        <Grid container spacing={6} sx={{ mb: { xs: 8, md: 10 } }} alignItems="center">
          <Grid size={{ xs: 12, md: 12 }}>
            <Typography
              variant="h4"
              sx={{
                fontFamily: '"Fraunces", serif',
                fontWeight: 700,
                color: '#F5F1E6',
                mb: 2.5,
              }}
            >
              Our Journey
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(245, 241, 230, 0.8)', mb: 2, lineHeight: 1.7 }}>
              Founded with the goal of eliminating expired codes, bait-and-switch discounts, and endless redirect loops, iSoret brings transparency back to online saving.
            </Typography>
            <Typography variant="body1" sx={{ color: 'rgba(245, 241, 230, 0.8)', lineHeight: 1.7 }}>
              Our dedicated curation team and advanced API checks verify every coupon listed on our platform, ensuring you get exactly what you claim, without the hassle.
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <Grid container spacing={3}>
              {/* Stat 1 */}
              <Grid size={{ xs: 6, md: 3 }}>
                <Paper
                  elevation={0}
                  sx={{
                    background: 'rgba(21, 58, 53, 0.4)',
                    border: '1px solid rgba(245, 241, 230, 0.08)',
                    borderRadius: '16px',
                    padding: 3,
                    textAlign: 'center',
                  }}
                >
                  <Typography variant="h3" sx={{ color: '#D4A24C', fontWeight: 700, fontFamily: '"Fraunces", serif', mb: 0.5 }}>
                    50K+
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'rgba(245, 241, 230, 0.6)' }}>
                    Active Users
                  </Typography>
                </Paper>
              </Grid>

              {/* Stat 2 */}
              <Grid size={{ xs: 6, md: 3 }}>
                <Paper
                  elevation={0}
                  sx={{
                    background: 'rgba(21, 58, 53, 0.4)',
                    border: '1px solid rgba(245, 241, 230, 0.08)',
                    borderRadius: '16px',
                    padding: 3,
                    textAlign: 'center',
                  }}
                >
                  <Typography variant="h3" sx={{ color: '#D4A24C', fontWeight: 700, fontFamily: '"Fraunces", serif', mb: 0.5 }}>
                    100+
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'rgba(245, 241, 230, 0.6)' }}>
                    Partner Brands
                  </Typography>
                </Paper>
              </Grid>

              {/* Stat 3 */}
              <Grid size={{ xs: 6, md: 3 }}>
                <Paper
                  elevation={0}
                  sx={{
                    background: 'rgba(21, 58, 53, 0.4)',
                    border: '1px solid rgba(245, 241, 230, 0.08)',
                    borderRadius: '16px',
                    padding: 3,
                    textAlign: 'center',
                  }}
                >
                  <Typography variant="h3" sx={{ color: '#D4A24C', fontWeight: 700, fontFamily: '"Fraunces", serif', mb: 0.5 }}>
                    35%
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'rgba(245, 241, 230, 0.6)' }}>
                    Avg. Savings
                  </Typography>
                </Paper>
              </Grid>

              {/* Stat 4 */}
              <Grid size={{ xs: 6, md: 3 }}>
                <Paper
                  elevation={0}
                  sx={{
                    background: 'rgba(21, 58, 53, 0.4)',
                    border: '1px solid rgba(245, 241, 230, 0.08)',
                    borderRadius: '16px',
                    padding: 3,
                    textAlign: 'center',
                  }}
                >
                  <Typography variant="h3" sx={{ color: '#D4A24C', fontWeight: 700, fontFamily: '"Fraunces", serif', mb: 0.5 }}>
                    ₹2M+
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'rgba(245, 241, 230, 0.6)' }}>
                    User Savings
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Pillars Section */}
        <Typography
          variant="h4"
          align="center"
          sx={{
            fontFamily: '"Fraunces", serif',
            fontWeight: 700,
            color: '#F5F1E6',
            mb: { xs: 5, md: 6 },
          }}
        >
          Our Core Values
        </Typography>

        <Grid container spacing={4}>
          {/* Pillar 1 */}
          <Grid size={{ xs: 12, md: 4 }}>
            <Paper
              elevation={0}
              sx={{
                background: 'rgba(21, 58, 53, 0.6)',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(245, 241, 230, 0.12)',
                borderRadius: '24px',
                padding: 4,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
              }}
            >
              <Avatar sx={{ backgroundColor: 'rgba(212, 162, 76, 0.12)', color: '#D4A24C', width: 60, height: 60, mb: 2.5 }}>
                <Verified sx={{ fontSize: '30px' }} />
              </Avatar>
              <Typography variant="h6" sx={{ color: '#F5F1E6', fontWeight: 600, mb: 1.5, fontFamily: '"Fraunces", serif' }}>
                100% Verified Deals
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(245, 241, 230, 0.66)', lineHeight: 1.6 }}>
                Every single discount code, coupon, and voucher is tested and validated daily to ensure they work at checkout.
              </Typography>
            </Paper>
          </Grid>

          {/* Pillar 2 */}
          <Grid size={{ xs: 12, md: 4 }}>
            <Paper
              elevation={0}
              sx={{
                background: 'rgba(21, 58, 53, 0.6)',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(245, 241, 230, 0.12)',
                borderRadius: '24px',
                padding: 4,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
              }}
            >
              <Avatar sx={{ backgroundColor: 'rgba(212, 162, 76, 0.12)', color: '#D4A24C', width: 60, height: 60, mb: 2.5 }}>
                <FlashOn sx={{ fontSize: '30px' }} />
              </Avatar>
              <Typography variant="h6" sx={{ color: '#F5F1E6', fontWeight: 600, mb: 1.5, fontFamily: '"Fraunces", serif' }}>
                Instant Claiming
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(245, 241, 230, 0.66)', lineHeight: 1.6 }}>
                One-click integration and claiming routes ensure that saving money is fast, intuitive, and simple.
              </Typography>
            </Paper>
          </Grid>

          {/* Pillar 3 */}
          <Grid size={{ xs: 12, md: 4 }}>
            <Paper
              elevation={0}
              sx={{
                background: 'rgba(21, 58, 53, 0.6)',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(245, 241, 230, 0.12)',
                borderRadius: '24px',
                padding: 4,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
              }}
            >
              <Avatar sx={{ backgroundColor: 'rgba(212, 162, 76, 0.12)', color: '#D4A24C', width: 60, height: 60, mb: 2.5 }}>
                <Security sx={{ fontSize: '30px' }} />
              </Avatar>
              <Typography variant="h6" sx={{ color: '#F5F1E6', fontWeight: 600, mb: 1.5, fontFamily: '"Fraunces", serif' }}>
                Secure Transactions
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(245, 241, 230, 0.66)', lineHeight: 1.6 }}>
                We respect your privacy. No personal data leaks, third-party selling, or bait tracking code scripts.
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
